export default {
  optimized_checkout: {
    its_event_manager: {},
  },
};
